import { validateIsEmail } from './validateIsEmail';

export const extractLocalPart = (email: string): string => {
  const localPart = validateIsEmail(email) ? email.split('@')[0] : '';
  return localPart;
};
